import React from "react";
import { Box, Typography, useMediaQuery, useTheme } from "@mui/material";
import ACTLogoA from "../assets/images/ACT-A-logo.png";
import ACTButton from "./ACTButton";

const goToTroubleshoot = () => {
};

const FailedPanel = (props) => {

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const {goToHomePanel, onGenerateQR, refreshQrCode} = props;
  return (
    <Box>
      <img
        src={ACTLogoA}
        alt="ACT logo"
        style={{
          width: isMobile ? "6rem" : "6rem",
          height: "auto",
          marginLeft: "2rem",
          marginTop: "-1.5rem",
          imageRendering: "crisp-edges",
        }}
      />
      <Typography
        sx={{
          maxWidth: "14rem",
          fontSize: "1.1rem",
          fontWeight: "500",
          lineHeight: "1.1",
          margin: isMobile ? "1rem auto 1.5rem auto" : "0.5rem auto 1rem auto",
        }}
      >
        Welcome back.
        <br />
        <span style={{ color: "#d41212" }}>
          Your browser location has not been Verified
        </span>
      </Typography>

      <Typography
        sx={{
          maxWidth: "12.5rem",
          fontSize: "0.9rem",
          fontWeight: "500",
          lineHeight: "1.2",
          margin: isMobile ? "2.4rem auto 0 auto" : "1.75rem auto 0.8rem auto",
        }}
      >
        To try again please
      </Typography>
      <Box
        sx={{
          width: "17rem",
          margin: "1rem auto 0 auto",
        }}
      >
        <ACTButton
          content="Request New QR Code"
          onClick={onGenerateQR}
          bgColor="#E54F9C"
          textColor="#ffffff"
          hoverColor="#b33b78"
          hoverTextColor="#ffffff"
          border="0.1rem solid #E54F9C"
          hoverBorder="0.1rem solid #b33b78"
        />
      </Box>
      <button onClick={goToTroubleshoot}>
        <Typography
          sx={{
            maxWidth: "12.5rem",
            fontSize: "0.8rem",
            fontWeight: "500",
            margin: "1rem auto 0 auto",
            color: "#000000",
            textDecoration: "underline",
            cursor: "pointer",
            "&:hover": {
              opacity: "0.65", 
            },
          }}
        >
          Troubleshoot
        </Typography>
      </button>
    </Box>
  );
};

export default FailedPanel;
